import { Component } from '@angular/core';
import { PanelBaseComponent } from 'projects/shared-components/panels/panel-base.component';

@Component({
   selector: 'ets-hedging-grid-panel',
   template: `
<div class="panel-container" [ngClass]="{'ets-hidden': !this.isActive}">
   <ets-hedging-grid [panelId]="panelId" [layoutTabId]="layoutTabId" [panelActive]="isActive"></ets-hedging-grid>
</div>
`,
   styles: [`
      .panel-container {
         width: 100%;
         height: 100%;
      }
   `]
})
export class HedgingGridPanelComponent extends PanelBaseComponent {
   
   etsOnInit(): void {
   }
   
   etsOnDestroy(): void {
   }
   
   etsAfterViewInit(): void {
   }
   
   protected getState() {
      return null;
   }
   
   protected setState(state: any) {
      // 
   }
}
